export { default } from "./GlobalErrorComponent";
